import React from "react";
import { Link } from "react-router-dom";
import "../styles/Navbar.css";

const Navbar = () => {
  return (
    <nav className="navbar">
      <ul className="navbar-links">
        <a href="/#features">Funcionalidades</a>
        <a href="/#testimonials">O que dizem</a>
        {/*<a href="/#pricing">Planos e Preços</a>*/}
        <a href="mailto:contato@rondago.com.br">Contato</a>

        {/* ✅ Sempre visível no Mobile e Desktop */}
        <Link to="/portal" className="button portal-button">
          Portal
        </Link>
      </ul>
    </nav>
  );
};

export default Navbar;
